
import { Component, Vue } from 'vue-property-decorator';
import { filterTenantDisplay } from "@/utils/tenantHelpers";

@Component({
  name: 'PointsStructure',
})
export default class PointsStructure extends Vue {
  brands = [
    { name: 'GUD', logo: 'gud_logo.png', image: 'gud-products.jpg', link: { name: 'BrandPointsStructure', params: { brand: 'GUD' } } },
    { name: 'FRAM', logo: 'fram_logo.jpg', image: 'fram-products.jpg', link: { name: 'BrandPointsStructure', params: { brand: 'FRAM' } }, tenantExclude: ["ZWE"] },
    { name: 'SAFELINE', logo: 'safeline_logo.png', image: 'safeline-products.jpg', link: { name: 'BrandPointsStructure', params: { brand: 'SAFELINE' } } },
    { name: 'HOLTS', logo: 'holts_logo.jpg', image: 'holts-products.jpg', link: { name: 'BrandPointsStructure', params: { brand: 'HOLTS' } } },
    { name: 'INDY', logo: 'indyoil_logo.png', image: 'indy-products.jpg', link: { name: 'BrandPointsStructure', params: { brand: 'INDY' } } },
  ];

  get brandDisplay() {
    return filterTenantDisplay(this.brands);
  }
}
